import { Anchor, Popover } from '@enterprise-ui/canvas-ui-react'
import copy from 'clipboard-copy'
import { useCallback } from 'react'

/**
 * Render prop component that wraps element in a Tooltip that shows "Copied to clipboard!" when the
 * copy function is invoked
 */
const CopyToClipboard = ({ TooltipProps = {}, children }) => {
  // Function to handle copy action and show tooltip
  const onCopy = useCallback((content) => {
    copy(content)
  }, [])

  return children ? (
    <Popover
      type="clickOnly"
      size="dense"
      location="top"
      content={<p>Copied to clipboard!</p>}
    >
      <Anchor>{children({ copy: onCopy })}</Anchor>
    </Popover>
  ) : null
}

export default CopyToClipboard
